










import { Component, Vue } from 'vue-property-decorator';
import topNav from './nav.vue';
import bottomInfo from './bottom.vue';

@Component({
  components: {
    topNav,
    bottomInfo
  },
})
export default class layout extends Vue {

}
